import { init } from '@sentry/browser';

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  init({
    dsn: process.env.SENTRY_URL,
    environment: process.env.NODE_ENV,
  });
}
